import DashboardLayout from "layouts/DashboardLayout";
import React, { useEffect, useState } from "react";
import { userData } from "utils/userData";
import styled from "styled-components";
import { AiOutlineDown /* AiOutlineStar */ } from "react-icons/ai";
//eslint-disable-next-line
import { BsFillCalendarWeekFill } from "react-icons/bs";
import { VscCircleFilled } from "react-icons/vsc";
//import Analysis from "chartPages/Analysis";
//import Analysis from "chartPages/Analysis";
import { ApiService } from "services";
import { toast } from "react-hot-toast";
import moment from "moment";
import { FormInput } from "components";
import { handleCheckMetric } from "utils/handleMetricsChekc";
import Skeleton2 from "components/Skeleton2";
import TransactionPerformanceSingle from "chartPages/TransactionPerformanceSingle";
export default function InstitutionPerformanceMetric() {
  console.log(userData);
  //eslint-disable-next-line
  const color = "#200E32";
  //eslint-disable-next-line

  //eslint-disable-next-line
  const [searchInput, setSearchInput] = useState("");
  const savedData = JSON.parse(localStorage.getItem("transactionPerformance"));

  const [secondsEnter, setSecondsEnter] = useState(
    Number(savedData?.seconds || 300)
  );
  const [secondsEnter2, setSecondsEnter2] = useState(
    Number(savedData?.seconds || 300)
  );
  const [secondsOpen, setSecondsOpen] = useState(false);

  const [loading2, setLoading2] = useState(false);

  const [transactionPerformance, setTransactionPerformance] = useState();

  useEffect(() => {
    localStorage.setItem(
      "transactionPerformance",
      JSON.stringify({
        transactionPerformance:
          transactionPerformance || savedData?.transactionPerformance,
        seconds: secondsEnter2,
      })
    );

    //eslint-disable-next-line
  }, [transactionPerformance]);

  //eslint-disable-next-line
  const [dateFrom, setDateFrom] = useState();
  //eslint-disable-next-line
  const [dateTo, setDateTo] = useState();

  /* INSTITUTION DASH */

  /* MAIN DASH */

  const getTransactionPerformance = async (param) => {
    if (
      userData?.userDetail?.role === "chiefAdmin" ||
      userData?.userDetail?.role === "subAdmin1" ||
      userData?.userDetail?.role === "subAdmin2"
    ) {
      setLoading2(true);
      try {
        const data = await ApiService.getDashboardAnalysis(param);
        setLoading2(false);
        setTransactionPerformance(data?.data);
      } catch (err) {
        console.log(err);
        setLoading2(false);
        if (err?.message === "It's not you, it's us. Try again later.") {
        } else if (err?.message === "Network Error") {
          return;
        } else {
          toast.error(err?.response?.data?.message || err?.message);
        }
      }
    }
  };

  const getTransactionPerformanceLoad = async (param) => {
    if (
      userData?.userDetail?.role === "chiefAdmin" ||
      userData?.userDetail?.role === "subAdmin1" ||
      userData?.userDetail?.role === "subAdmin2"
    ) {
      try {
        const data = await ApiService.getDashboardAnalysis(param);
        setTransactionPerformance(data?.data);
      } catch (err) {
        console.log(err);
        if (err?.message === "It's not you, it's us. Try again later.") {
        } else if (err?.message === "Network Error") {
          return;
        } else {
          toast.error(err?.response?.data?.message || err?.message);
        }
      }
    }
  };

  const transactionPerformanceData =
    transactionPerformance?.[0] || savedData?.transactionPerformance?.[0] || {};

  const transactionPerformanceInfo =
    transactionPerformanceData?.transactionPerformance || [];

  const [boundType2, setBoundType2] = useState("Inbound");
  const [institutionType, setInstitutionType] = useState("");

  //eslint-disable-next-line
  const [dateFilter, setDateFilter] = useState(false);

  useEffect(() => {
    if (savedData) {
      return;
    } else {
      getTransactionPerformance(
        `?reportType=transactionPerformance&indicatorLastPeriod=${secondsEnter}`
      );
    }

    //eslint-disable-next-line
  }, []);

  function formatTime(seconds) {
    return [
      seconds / 60 / 60 / 24 >= 1
        ? `${parseInt(seconds / 60 / 60 / 24)}d `
        : "",
      seconds / 60 / 60 < 24
        ? seconds / 60 / 60 === 0
          ? ""
          : `${parseInt(seconds / 60 / 60)}h `
        : "",
      (seconds / 60) % 60 !== 0 ? `${parseInt((seconds / 60) % 60)}m ` : "",
      seconds % 60 !== 0 ? `${parseInt(seconds % 60)}s` : "",
    ]
      .join("")
      .replace(/\b(\d)\b/g, "0$1");
  }
  useEffect(() => {
    const interval = setInterval(() => {
      if (userData?.userDetail?.role === "chiefAdmin") {
        getTransactionPerformanceLoad(
          `?reportType=transactionPerformance&indicatorLastPeriod=${secondsEnter}`
        );
      } else {
        if (
          handleCheckMetric(
            "transactionPerformance",
            userData?.userDetail?.metrics
          )
        ) {
          getTransactionPerformanceLoad(
            `?reportType=transactionPerformance&indicatorLastPeriod=${secondsEnter}`
          );
        }
      }
    }, secondsEnter2 * 1000);
    return () => clearInterval(interval);

    //eslint-disable-next-line
  }, [secondsEnter2]);

  /* CHART CONFIGS */

  const options2 = {
    series: [
      {
        name: "Success",
        data: transactionPerformanceInfo?.map((item) => item?.success) || [],
        color: "#01A926",
      },
      {
        name: "Pending",
        data: transactionPerformanceInfo?.map((item) => item?.pending) || [],
        color: "#FF993A",
      },
      {
        name: "Failed",
        data: transactionPerformanceInfo?.map((item) => item?.failed) || [],
        color: "#FF2E00",
      },
    ],
    options: {
      tooltip: {
        enabled: true,
        enabledOnSeries: undefined,
        shared: true,
        followCursor: false,
        intersect: false,
        style: {
          fontSize: "12px",
          fontFamily: undefined,
        },
        onDatasetHover: {
          highlightDataSeries: false,
        },
        x: {
          show: true,
        },
        y: {
          formatter: function (val) {
            return Math.abs(val) > 999999999
              ? ` ${Math.sign(val) * (Math.abs(val) / 1000000000).toFixed(1)}B`
              : Math.abs(val) > 999999
              ? `${Math.sign(val) * (Math.abs(val) / 1000000).toFixed(1)}M`
              : Math.abs(val) > 999
              ? `${Math.sign(val) * (Math.abs(val) / 1000).toFixed(1)}k`
              : Math.sign(val) * Math.abs(val);
          },
          title: {
            formatter: (seriesName) => seriesName,
          },
        },
        z: {
          formatter: function (val) {
            return Math.abs(val) > 999999999
              ? `${Math.sign(val) * (Math.abs(val) / 1000000000).toFixed(1)}B`
              : Math.abs(val) > 999999
              ? `${Math.sign(val) * (Math.abs(val) / 1000000).toFixed(1)}M`
              : Math.abs(val) > 999
              ? `${Math.sign(val) * (Math.abs(val) / 1000).toFixed(1)}k`
              : Math.sign(val) * Math.abs(val);
          },
          title: "Size: ",
        },
        marker: {
          show: true,
        },
        items: {
          display: "flex",
        },
        fixed: {
          enabled: false,
          position: "topRight",
          offsetX: 0,
          offsetY: 0,
        },
      },
      labels:
        transactionPerformanceInfo?.map((item) =>
          boundType2 === "Inbound"
            ? item?.successInbound
            : item?.successOutbound
        ) || [],

      chart: {
        type: "bar",
        height: "100%",
        width: "100%",
        stacked: true,
        toolbar: {
          show: false,
        },
        zoom: {
          enabled: true,
        },
      },
      responsive: [
        {
          breakpoint: 480,
          options: {
            legend: {
              position: "bottom",
              offsetX: -10,
              offsetY: 0,
            },
          },
        },
      ],
      plotOptions: {
        bar: {
          horizontal: false,
          borderRadius: 0,
          columnWidth: "36%",
          dataLabels: {
            total: {
              enabled: false,
              style: {
                fontSize: "0px",
                fontWeight: 10,
              },
            },
          },
        },
      },
      xaxis: {
        categories:
          transactionPerformanceInfo?.map((item) => item?.institution) || [],
        labels: {
          rotate: 0,

          style: {
            fontSize: "12px",
          },
        },
      },
      yaxis: {
        labels: {
          formatter: function (val) {
            return Math.abs(val) > 999999999
              ? ` ${Math.sign(val) * (Math.abs(val) / 1000000000).toFixed(1)}B`
              : Math.abs(val) > 999999
              ? `${Math.sign(val) * (Math.abs(val) / 1000000).toFixed(1)}M`
              : Math.abs(val) > 999
              ? `${Math.sign(val) * (Math.abs(val) / 1000).toFixed(1)}k`
              : Math.sign(val) * Math.abs(val);
          },
        },
      },
      legend: {
        show: false,
      },
      fill: {
        opacity: 1,
      },
      dataLabels: {
        enabled: false,
      },
    },
  };

  function followingDay1(date = new Date()) {
    date.setDate(date.getDate() + 1);

    return date;
  }

  const followingDay = followingDay1();

  return (
    <DashboardLayout>
      {userData?.userDetail?.role === "chiefAdmin" && (
        <>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "flex-start",
            }}
          >
            <Head>
              <div className="top">
                <p style={{ margin: 0 }}>Site Performance Indicator</p>
              </div>
            </Head>
            <SelectInput name="" id="">
              <select
                onChange={(e) => {
                  getTransactionPerformance(
                    `?institutionType=${e.target.value}${
                      dateFrom && dateTo
                        ? `${`&dateFrom=${dateFrom}&dateTo=${dateTo}`}`
                        : ""
                    }&reportType=transactionPerformance`
                  );

                  setInstitutionType(e.target.value);
                }}
              >
                <option value="" selected>
                  All
                </option>
                <option value="bank">Bank Institutions</option>
                <option value="nonBank">Non-Bank Institutions</option>
              </select>
              <svg
                className="icon"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M8.69891 11.4136L11.2385 14.0036C11.6209 14.3936 12.2386 14.3936 12.621 14.0036L15.1606 11.4136C15.7783 10.7836 15.3371 9.70361 14.4644 9.70361H9.38528C8.51261 9.70361 8.08117 10.7836 8.69891 11.4136Z"
                  fill="#019EDF"
                />
              </svg>
            </SelectInput>
          </div>
          <Head>
            <div className="top">
              <span>Today, {formatTime(secondsEnter2)} ago</span>
            </div>
            <div className="timerate">
              <span
                onClick={() => {
                  setSecondsOpen(!secondsOpen);
                  setDateFilter(false);
                }}
                style={{ position: "relative", cursor: "pointer" }}
              >
                Filter By Last {secondsEnter} Seconds <AiOutlineDown />
                {secondsOpen && (
                  <DropDown
                    onClick={(e) => {
                      e.stopPropagation();
                    }}
                    style={{ cursor: "default", width: "300px" }}
                  >
                    <div className="title" style={{ padding: "10px 0" }}>
                      Fetch Time Frame
                    </div>
                    <form
                      onSubmit={(e) => {
                        e.preventDefault();
                        if (secondsEnter >= 300) {
                          getTransactionPerformance(
                            `?reportType=transactionPerformance&indicatorLastPeriod=${secondsEnter}${
                              institutionType
                                ? `&institutionType=${institutionType}`
                                : ""
                            }&`
                          );

                          setSecondsEnter2(secondsEnter);
                        } else {
                          toast.error("Must not be less than 15 seconds");
                        }
                      }}
                    >
                      <FormInput
                        onChange={(e) => {
                          setSecondsEnter(e.target.value);
                        }}
                        type="number"
                        background="#F2F7FF"
                        padding="10px 14px"
                        placeholder="Enter Seconds"
                      />
                    </form>
                    <svg
                      style={{
                        position: "absolute",
                        top: "50%",
                        right: "30px",
                        transform: "translateY(50%)",
                        cursor: "pointer",
                      }}
                      onClick={() => {
                        if (secondsEnter >= 300) {
                          setSecondsEnter2(secondsEnter);
                        } else {
                          toast.error("Must not be less than 15 seconds");
                        }
                      }}
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g clip-path="url(#clip0_505_4722)">
                        <path
                          d="M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20Z"
                          fill="#00B3FE"
                        />
                        <path
                          d="M15.1196 9.12419C13.979 7.98365 12.8387 6.84311 11.6981 5.70258C10.6189 4.62314 8.95014 6.30466 10.0321 7.38663C10.497 7.85149 10.9619 8.31638 11.4267 8.78141C9.59614 8.78141 7.76556 8.78141 5.93516 8.78141C4.40556 8.78141 4.39213 11.1506 5.9181 11.1506C7.7545 11.1506 9.5909 11.1506 11.4272 11.1506C10.9592 11.6186 10.4911 12.0866 10.0231 12.5547C8.94368 13.6339 10.6252 15.3027 11.7072 14.2207C12.8477 13.0803 13.9881 11.94 15.1286 10.7994C15.5865 10.3413 15.574 9.57849 15.1196 9.12419Z"
                          fill="white"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_505_4722">
                          <rect width="20" height="20" fill="white" />
                        </clipPath>
                      </defs>
                    </svg>
                  </DropDown>
                )}
              </span>
            </div>
          </Head>

          <TransactionPerformanc>
            <FlexPerformance>
              <div className="performance">
                <span>Statistics</span>
                <p>Transaction Performance</p>
              </div>

              <div className="btn">
                <button
                  onClick={() => {
                    getTransactionPerformance(
                      `?reportType=transactionPerformance&indicatorLastPeriod=${secondsEnter}${
                        institutionType
                          ? `&institutionType=${institutionType}`
                          : ""
                      }&dateFrom=${moment(new Date()).format(
                        "DD-MM-YYYY "
                      )}&dateTo=${moment(followingDay).format("DD-MM-YYYY ")}`
                    );
                  }}
                  style={{
                    backgroundColor: "#FFC371",
                    color: "white",
                    cursor: "pointer",
                  }}
                >
                  Today
                </button>
                <button
                  onClick={() => {
                    setBoundType2("Inbound");
                    getTransactionPerformance(
                      `?reportType=transactionPerformance&direction=inbound&indicatorLastPeriod=${secondsEnter}${
                        institutionType
                          ? `&institutionType=${institutionType}`
                          : ""
                      }&dateFrom=${moment(new Date()).format(
                        "DD-MM-YYYY "
                      )}&dateTo=${moment(followingDay).format("DD-MM-YYYY ")}`
                    );
                  }}
                  style={{
                    backgroundColor: boundType2 === "Inbound" && "#14A2FD",
                    color: boundType2 !== "Inbound" ? "gray" : "white",
                    border: boundType2 !== "Inbound" && "1px solid gainsboro",
                    cursor: "pointer",
                  }}
                >
                  Inbound Performance
                </button>
                <button
                  onClick={() => {
                    setBoundType2("Outbound");
                    getTransactionPerformance(
                      `?reportType=transactionPerformance&direction=outbound&indicatorLastPeriod=${secondsEnter}${
                        institutionType
                          ? `&institutionType=${institutionType}`
                          : ""
                      }&dateFrom=${moment(new Date()).format(
                        "DD-MM-YYYY "
                      )}&dateTo=${moment(followingDay).format("DD-MM-YYYY ")}`
                    );
                  }}
                  style={{
                    backgroundColor: boundType2 === "Outbound" && "#14A2FD",
                    color: boundType2 !== "Outbound" ? "gray" : "white",
                    border: boundType2 !== "Outbound" && "1px solid gainsboro",
                    cursor: "pointer",
                  }}
                >
                  Outbound Performance
                </button>

                <div className="outwardTransaction">
                  <VscCircleFilled style={{ color: "#01A926" }} size={15} />
                  Successful Transaction
                </div>
                <div className="outwardTransaction">
                  <VscCircleFilled style={{ color: "#FF993A" }} size={15} />
                  Pending Transaction
                </div>
                <div className="outwardTransaction">
                  <VscCircleFilled style={{ color: "#FF0000" }} size={15} />
                  Failed Transaction
                </div>
              </div>
            </FlexPerformance>
            {loading2 ? (
              <Skeleton2 height="300px" />
            ) : (
              <TransactionPerformanceSingle options={options2} />
            )}
          </TransactionPerformanc>
          <br></br>
          <br></br>
        </>
      )}

      {userData?.userDetail?.role === "subAdmin1" && (
        <>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "flex-start",
            }}
          >
            <Head>
              <div className="top">
                <p style={{ margin: 0 }}>Site Performance Indicator</p>
              </div>
            </Head>
            <SelectInput name="" id="">
              <select
                onChange={(e) => {
                  getTransactionPerformance(
                    `?institutionType=${e.target.value}&reportType=transactionPerformance`
                  );

                  setInstitutionType(e.target.value);
                }}
              >
                <option value="" selected>
                  All
                </option>
                <option value="bank">Bank Institutions</option>
                <option value="nonBank">Non-Bank Institutions</option>
              </select>
              <svg
                className="icon"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M8.69891 11.4136L11.2385 14.0036C11.6209 14.3936 12.2386 14.3936 12.621 14.0036L15.1606 11.4136C15.7783 10.7836 15.3371 9.70361 14.4644 9.70361H9.38528C8.51261 9.70361 8.08117 10.7836 8.69891 11.4136Z"
                  fill="#019EDF"
                />
              </svg>
            </SelectInput>
          </div>
          <Head>
            <div className="top">
              <span>Today, {formatTime(secondsEnter2)} ago</span>
            </div>
            <div className="timerate">
              <span
                onClick={() => {
                  setSecondsOpen(!secondsOpen);
                  setDateFilter(false);
                }}
                style={{ position: "relative", cursor: "pointer" }}
              >
                Filter By Last {secondsEnter} Seconds <AiOutlineDown />
                {secondsOpen && (
                  <DropDown
                    onClick={(e) => {
                      e.stopPropagation();
                    }}
                    style={{ cursor: "default", width: "300px" }}
                  >
                    <div className="title" style={{ padding: "10px 0" }}>
                      Fetch Time Frame
                    </div>
                    <form
                      onSubmit={(e) => {
                        e.preventDefault();
                        if (secondsEnter >= 300) {
                          getTransactionPerformance(
                            `?reportType=transactionPerformance&indicatorLastPeriod=${secondsEnter}${
                              institutionType
                                ? `&institutionType=${institutionType}`
                                : ""
                            }&`
                          );

                          setSecondsEnter2(secondsEnter);
                        } else {
                          toast.error("Must not be less than 15 seconds");
                        }
                      }}
                    >
                      <FormInput
                        onChange={(e) => {
                          setSecondsEnter(e.target.value);
                        }}
                        type="number"
                        background="#F2F7FF"
                        padding="10px 14px"
                        placeholder="Enter Seconds"
                      />
                    </form>
                    <svg
                      style={{
                        position: "absolute",
                        top: "50%",
                        right: "30px",
                        transform: "translateY(50%)",
                        cursor: "pointer",
                      }}
                      onClick={() => {
                        if (secondsEnter >= 300) {
                          setSecondsEnter2(secondsEnter);
                        } else {
                          toast.error("Must not be less than 15 seconds");
                        }
                      }}
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g clip-path="url(#clip0_505_4722)">
                        <path
                          d="M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20Z"
                          fill="#00B3FE"
                        />
                        <path
                          d="M15.1196 9.12419C13.979 7.98365 12.8387 6.84311 11.6981 5.70258C10.6189 4.62314 8.95014 6.30466 10.0321 7.38663C10.497 7.85149 10.9619 8.31638 11.4267 8.78141C9.59614 8.78141 7.76556 8.78141 5.93516 8.78141C4.40556 8.78141 4.39213 11.1506 5.9181 11.1506C7.7545 11.1506 9.5909 11.1506 11.4272 11.1506C10.9592 11.6186 10.4911 12.0866 10.0231 12.5547C8.94368 13.6339 10.6252 15.3027 11.7072 14.2207C12.8477 13.0803 13.9881 11.94 15.1286 10.7994C15.5865 10.3413 15.574 9.57849 15.1196 9.12419Z"
                          fill="white"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_505_4722">
                          <rect width="20" height="20" fill="white" />
                        </clipPath>
                      </defs>
                    </svg>
                  </DropDown>
                )}
              </span>
            </div>
          </Head>

          {handleCheckMetric(
            "transactionPerformance",
            userData?.userDetail?.metrics
          ) && (
            <TransactionPerformanc>
              <FlexPerformance>
                <div className="performance">
                  <span>Statistics</span>
                  <p>Transaction Performance</p>
                </div>

                <div className="btn">
                  <button
                    onClick={() => {
                      getTransactionPerformance(
                        `?reportType=transactionPerformance&indicatorLastPeriod=${secondsEnter}${
                          institutionType
                            ? `&institutionType=${institutionType}`
                            : ""
                        }&dateFrom=${moment(new Date()).format(
                          "DD-MM-YYYY "
                        )}&dateTo=${moment(followingDay).format("DD-MM-YYYY ")}`
                      );
                    }}
                    style={{
                      backgroundColor: "#FFC371",
                      color: "white",
                      cursor: "pointer",
                    }}
                  >
                    Today
                  </button>
                  <button
                    onClick={() => {
                      setBoundType2("Inbound");
                      getTransactionPerformance(
                        `?reportType=transactionPerformance&direction=inbound&indicatorLastPeriod=${secondsEnter}${
                          institutionType
                            ? `&institutionType=${institutionType}`
                            : ""
                        }&dateFrom=${moment(new Date()).format(
                          "DD-MM-YYYY "
                        )}&dateTo=${moment(followingDay).format("DD-MM-YYYY ")}`
                      );
                    }}
                    style={{
                      backgroundColor: boundType2 === "Inbound" && "#14A2FD",
                      color: boundType2 !== "Inbound" ? "gray" : "white",
                      border: boundType2 !== "Inbound" && "1px solid gainsboro",
                      cursor: "pointer",
                    }}
                  >
                    Inbound Performance
                  </button>
                  <button
                    onClick={() => {
                      setBoundType2("Outbound");
                      getTransactionPerformance(
                        `?reportType=transactionPerformance&direction=outbound&indicatorLastPeriod=${secondsEnter}${
                          institutionType
                            ? `&institutionType=${institutionType}`
                            : ""
                        }&dateFrom=${moment(new Date()).format(
                          "DD-MM-YYYY "
                        )}&dateTo=${moment(followingDay).format("DD-MM-YYYY ")}`
                      );
                    }}
                    style={{
                      backgroundColor: boundType2 === "Outbound" && "#14A2FD",
                      color: boundType2 !== "Outbound" ? "gray" : "white",
                      border:
                        boundType2 !== "Outbound" && "1px solid gainsboro",
                      cursor: "pointer",
                    }}
                  >
                    Outbound Performance
                  </button>

                  <div className="outwardTransaction">
                    <VscCircleFilled style={{ color: "#01A926" }} size={15} />
                    Successful Transaction
                  </div>
                  <div className="outwardTransaction">
                    <VscCircleFilled style={{ color: "#FF993A" }} size={15} />
                    Pending Transaction
                  </div>
                  <div className="outwardTransaction">
                    <VscCircleFilled style={{ color: "#FF0000" }} size={15} />
                    Failed Transaction
                  </div>
                </div>
              </FlexPerformance>
              {loading2 ? (
                <Skeleton2 height="300px" />
              ) : (
                <TransactionPerformanceSingle options={options2} />
              )}{" "}
            </TransactionPerformanc>
          )}
          <br></br>
          <br></br>
        </>
      )}
      {userData?.userDetail?.role === "subAdmin2" && (
        <>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "flex-start",
            }}
          >
            <Head>
              <div className="top">
                <p style={{ margin: 0 }}>Site Performance Indicator</p>
              </div>
            </Head>
            <SelectInput name="" id="">
              <select
                onChange={(e) => {
                  getTransactionPerformance(
                    `?institutionType=${e.target.value}&reportType=transactionPerformance`
                  );

                  setInstitutionType(e.target.value);
                }}
              >
                <option value="" selected>
                  All
                </option>
                <option value="bank">Bank Institutions</option>
                <option value="nonBank">Non-Bank Institutions</option>
              </select>
              <svg
                className="icon"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M8.69891 11.4136L11.2385 14.0036C11.6209 14.3936 12.2386 14.3936 12.621 14.0036L15.1606 11.4136C15.7783 10.7836 15.3371 9.70361 14.4644 9.70361H9.38528C8.51261 9.70361 8.08117 10.7836 8.69891 11.4136Z"
                  fill="#019EDF"
                />
              </svg>
            </SelectInput>
          </div>
          <Head>
            <div className="top">
              <p>Site Performance Indicator</p>
              <span>Today, {formatTime(secondsEnter2)} ago</span>
            </div>
            <div className="timerate">
              <span
                onClick={() => {
                  setSecondsOpen(!secondsOpen);
                  setDateFilter(false);
                }}
                style={{ position: "relative", cursor: "pointer" }}
              >
                Filter By Last {secondsEnter} Seconds <AiOutlineDown />
                {secondsOpen && (
                  <DropDown
                    onClick={(e) => {
                      e.stopPropagation();
                    }}
                    style={{ cursor: "default", width: "300px" }}
                  >
                    <div className="title" style={{ padding: "10px 0" }}>
                      Fetch Time Frame
                    </div>
                    <form
                      onSubmit={(e) => {
                        e.preventDefault();
                        if (secondsEnter >= 300) {
                          getTransactionPerformance(
                            `?reportType=transactionPerformance&indicatorLastPeriod=${secondsEnter}${
                              institutionType
                                ? `&institutionType=${institutionType}`
                                : ""
                            }&`
                          );

                          setSecondsEnter2(secondsEnter);
                        } else {
                          toast.error("Must not be less than 15 seconds");
                        }
                      }}
                    >
                      <FormInput
                        onChange={(e) => {
                          setSecondsEnter(e.target.value);
                        }}
                        type="number"
                        background="#F2F7FF"
                        padding="10px 14px"
                        placeholder="Enter Seconds"
                      />
                    </form>
                    <svg
                      style={{
                        position: "absolute",
                        top: "50%",
                        right: "30px",
                        transform: "translateY(50%)",
                        cursor: "pointer",
                      }}
                      onClick={() => {
                        if (secondsEnter >= 300) {
                          setSecondsEnter2(secondsEnter);
                        } else {
                          toast.error("Must not be less than 15 seconds");
                        }
                      }}
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      {/* hekk */}
                      <g clip-path="url(#clip0_505_4722)">
                        <path
                          d="M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20Z"
                          fill="#00B3FE"
                        />
                        <path
                          d="M15.1196 9.12419C13.979 7.98365 12.8387 6.84311 11.6981 5.70258C10.6189 4.62314 8.95014 6.30466 10.0321 7.38663C10.497 7.85149 10.9619 8.31638 11.4267 8.78141C9.59614 8.78141 7.76556 8.78141 5.93516 8.78141C4.40556 8.78141 4.39213 11.1506 5.9181 11.1506C7.7545 11.1506 9.5909 11.1506 11.4272 11.1506C10.9592 11.6186 10.4911 12.0866 10.0231 12.5547C8.94368 13.6339 10.6252 15.3027 11.7072 14.2207C12.8477 13.0803 13.9881 11.94 15.1286 10.7994C15.5865 10.3413 15.574 9.57849 15.1196 9.12419Z"
                          fill="white"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_505_4722">
                          <rect width="20" height="20" fill="white" />
                        </clipPath>
                      </defs>
                    </svg>
                  </DropDown>
                )}
              </span>
            </div>
          </Head>

          {handleCheckMetric(
            "transactionPerformance",
            userData?.userDetail?.metrics
          ) && (
            <TransactionPerformanc>
              <FlexPerformance>
                <div className="performance">
                  <span>Statistics</span>
                  <p>Transaction Performance</p>
                </div>

                <div className="btn">
                  <button
                    onClick={() => {
                      getTransactionPerformance(
                        `?reportType=transactionPerformance&indicatorLastPeriod=${secondsEnter}${
                          institutionType
                            ? `&institutionType=${institutionType}`
                            : ""
                        }&dateFrom=${moment(new Date()).format(
                          "DD-MM-YYYY "
                        )}&dateTo=${moment(followingDay).format("DD-MM-YYYY ")}`
                      );
                    }}
                    style={{
                      backgroundColor: "#FFC371",
                      color: "white",
                      cursor: "pointer",
                    }}
                  >
                    Today
                  </button>
                  <button
                    onClick={() => {
                      setBoundType2("Inbound");
                      getTransactionPerformance(
                        `?reportType=transactionPerformance&direction=inbound&indicatorLastPeriod=${secondsEnter}${
                          institutionType
                            ? `&institutionType=${institutionType}`
                            : ""
                        }&dateFrom=${moment(new Date()).format(
                          "DD-MM-YYYY "
                        )}&dateTo=${moment(followingDay).format("DD-MM-YYYY ")}`
                      );
                    }}
                    style={{
                      backgroundColor: boundType2 === "Inbound" && "#14A2FD",
                      color: boundType2 !== "Inbound" ? "gray" : "white",
                      border: boundType2 !== "Inbound" && "1px solid gainsboro",
                      cursor: "pointer",
                    }}
                  >
                    Inbound Performance
                  </button>
                  <button
                    onClick={() => {
                      setBoundType2("Outbound");
                      getTransactionPerformance(
                        `?reportType=transactionPerformance&direction=outbound&indicatorLastPeriod=${secondsEnter}${
                          institutionType
                            ? `&institutionType=${institutionType}`
                            : ""
                        }&dateFrom=${moment(new Date()).format(
                          "DD-MM-YYYY "
                        )}&dateTo=${moment(followingDay).format("DD-MM-YYYY ")}`
                      );
                    }}
                    style={{
                      backgroundColor: boundType2 === "Outbound" && "#14A2FD",
                      color: boundType2 !== "Outbound" ? "gray" : "white",
                      border:
                        boundType2 !== "Outbound" && "1px solid gainsboro",
                      cursor: "pointer",
                    }}
                  >
                    Outbound Performance
                  </button>

                  <div className="outwardTransaction">
                    <VscCircleFilled style={{ color: "#01A926" }} size={15} />
                    Successful Transaction
                  </div>
                  <div className="outwardTransaction">
                    <VscCircleFilled style={{ color: "#FF993A" }} size={15} />
                    Pending Transaction
                  </div>
                  <div className="outwardTransaction">
                    <VscCircleFilled style={{ color: "#FF0000" }} size={15} />
                    Failed Transaction
                  </div>
                </div>
              </FlexPerformance>
              {loading2 ? (
                <Skeleton2 height="300px" />
              ) : (
                <TransactionPerformanceSingle options={options2} />
              )}
            </TransactionPerformanc>
          )}
          <br></br>
          <br></br>
        </>
      )}
      {/* hhh */}
    </DashboardLayout>
  );
}

const SelectInput = styled.div`
  position: relative;
  width: 300px;
  margin-left: auto;

  select {
    width: 100%;
    height: 100%;
    appearance: none;
    border-radius: 20px;
    outline: none;
    padding: 10px;
    font-size: 16px;
    background-color: white;
    margin-bottom: 20px;
    border: 1px solid #e6e7ec;
    color: #019edf;
  }
  .icon {
    position: absolute;
    top: 50%;
    right: 10px;
    transform: translateY(-90%);
    pointer-events: none;
  }
`;
const Head = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 30px;
  .top p {
    font-size: 30px;
    font-weight: 500;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .top span {
    font-size: 15px;
    color: #00a2e5;
    font-weight: 500;
  }
  .timerate {
    display: flex;
    align-items: center;
    gap: 20px;
  }
  .timerate span {
    font-size: 16px;
    display: flex;
    align-items: center;
    gap: 8px;
  }
  .timerate p {
    font-size: 12.5px;
    display: flex;
    align-items: center;
    gap: 15px;
  }
`;

const TransactionPerformanc = styled.div`
  padding: 12px;
  border-radius: 20px;
  background-color: white;
  margin-top: 20px;
`;

const FlexPerformance = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px;
  border-bottom: 1px solid gainsboro;
  .outwardTransaction {
    padding: 7px 10px 7px 10px;
    border-radius: 5px;
    font-size: 11px;
    display: flex;
    align-items: center;
    gap: 5px;
    border: 1px solid #e5e5ef;
  }

  span {
    color: gray;
  }
  .btn {
    display: flex;
    gap: 20px;
  }
  .btn button {
    padding: 5px;
    border: none;
    background-color: transparent;
    border-radius: 5px;
  }
  .gradient {
    background-color: #eff7fa;
    display: flex;
    align-items: center;
    gap: 20px;
    padding-left: 5px;
    border-radius: 5px;
  }
  .gradient select {
    background-color: #eff7fa;
    color: #333333;
    outline: none;
    padding: 5px;
    border: none;
    border-radius: 5px;
  }
  .gradient span {
    font-size: 12px;
  }
`;

const DropDown = styled.div`
  position: absolute;
  border: 1px solid #bbbbbb;
  border-radius: 20px;
  top: 180%;
  right: 0;
  background-color: white;
  z-index: 100;
  padding: 0 20px;
  padding-top: 8px;
  width: 220%;
  text-transform: capitalize;
  font-size: 14px;

  .title {
    border-bottom: 1px solid #e9e9e9;
    width: 100%;
    font-size: 14px;
    margin-bottom: 20px;
  }
`;
